export const isPublicRoute = (path: string) => {
  return (
    path === '/login' ||
    /^\/proposal\/token\/[A-Za-z0-9-]+\/[0-9]+$/g.test(path)
  );
};
